module.exports = __webpack_public_path__ + "img/background058.jpg";